export function Settings(): React.ReactElement {
  return <div data-testid="settings-page" />;
}
